import { render, staticRenderFns } from "./NewPackage.vue?vue&type=template&id=f2f1e6f0&"
import script from "./NewPackage.vue?vue&type=script&lang=js&"
export * from "./NewPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports